import React from 'react';
import PropTypes from 'prop-types';
import FilterForm from './FilterForm';

class Filter extends React.Component {
  render() {
    const {
      isFilterOpen,
      toggleAppetiteAccordion,
      toggleFilter,
      isAppetiteAccordionOpen,
    } = this.props;
    return (
      <section className="appetite">
        <div className="accordion__content-wrapper container">
          <h2 className="appetite__heading">Appetite</h2>
          <button
            className={`accordion__trigger ${isFilterOpen ? 'is-disabled' : ''}`}
            onClick={toggleAppetiteAccordion}
          >
            <i
              className={`${isAppetiteAccordionOpen ? 'fal fa-minus' : 'fal fa-plus'}`}
            />
          </button>
          <button
            className={`appetite__trigger appetite__trigger--filter ${
              isFilterOpen ? 'is-disabled' : ''
            }`}
            onClick={toggleFilter}
          >
            Filter &nbsp;
            <i className="fas fa-chevron-down" />
          </button>
          <section className={`appetite__wrap ${isFilterOpen ? 'is-active' : ''}`}>
            {isFilterOpen && (
              <FilterForm {...this.props} toggleFilter={toggleFilter} formMode="Desk" />
            )}
          </section>
        </div>
      </section>
    );
  }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/Filter.js